// extracted by mini-css-extract-plugin
module.exports = {"container":"MainInfoSection_container__H78jc"};